/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import wizardStyle from "@/src/components/Form/wizardStyle";
import Grid from "@mui/material/Grid";
import MenuItem from "@mui/material/MenuItem";
import { requiredValidator } from "@/src/services/validationRules";
import ValidatorTextField from "@/src/components/FormFields/ValidatorTextField";
import ValidatorSelectField from "@/src/components/FormFields/ValidatorSelectField";
import FormLegend from "@/src/components/Form/Common/FormLegend/FormLegend";
import NumberFieldConfigured from "@/src/components/Form/ConfiguredFormElements/NumberFieldConfigured/NumberFieldConfigured";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";

type ValuableProps = {
  path: string;
  index: number;
  product: AbstractCase;
};

export default function Valuable({ path, index, product }: ValuableProps) {
  return (
    <>
      <Grid sx={wizardStyle.gridTopSpaced} size={12}>
        <FormLegend>Bitte geben Sie hier weitere Details zu Ihrem {index + 1}. Wertgegenstand an.</FormLegend>
      </Grid>
      <Grid size={12}>
        <ValidatorTextField
          name={path + ".name"}
          label="Bezeichung des Wertgegenstandes"
          validators={[requiredValidator("Bitte geben Sie die Bezeichung des Wertgegenstandes an")]}
        />
      </Grid>
      <Grid size={12}>
        <ValidatorSelectField
          label="Allein- oder Miteigentum"
          name={path + ".ownership"}
          validators={[requiredValidator("Bitte geben Sie die Besitzverhältnisse an")]}
          MenuProps={{ slotProps: { paper: { style: { maxHeight: 200 } } } }}
        >
          <MenuItem value={"Alleineigentum"}>Alleineigentum</MenuItem>
          <MenuItem value={"Miteigentum"}>Miteigentum</MenuItem>
        </ValidatorSelectField>
      </Grid>
      <NumberFieldConfigured caseData={product} fieldPath={path + "value"} numberType={"float"} fieldType={"money"} required />
    </>
  );
}
